import { loggedIn, userSignedUp, userNotEmailVerified } from '../../../routes/conditional';
import paths from '../../../routes/paths';
import { fetchUserV3 } from '../../../redux/modules/user';

export const page = {
    path: paths.signup.verifyemail,
    isAllowed: [loggedIn, userSignedUp, userNotEmailVerified],
    action: () => fetchUserV3(),
};

export const actions = {};
